<template>
  <form-section>
    <p class="item-description">
      {{ $t('Integrations_Otp_Description') }}
    </p>
  </form-section>
</template>

<script>
import FormSection from '@/common/components/form/FormSection.vue'

export default {
  name: 'OtpOverview',

  components: { FormSection },

  props: {
    model: {
      required: false
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/modules/integrations/types/otp/OtpOverview.vue